import React from 'react';

const NotesSection = ({ formData, handleInputChange, isDark }) => {
    return (
        <div className={`border-solid border-[1px] rounded-[16px] p-[20px] shadow-[0px_4px_4px_0px_rgba(0,0,0,0.11)] w-full max-w-[822px] flex flex-col gap-[16px] hidden transition-colors duration-200 ${
            isDark ? 'bg-[#000000] border-[#292929]' : 'bg-white border-[#d9d9d9]'
        }`}>
            <div className={`text-[16px] font-semibold transition-colors duration-200 ${
                isDark ? 'text-white' : 'text-[#072837]'
            }`}>
                Notes
            </div>
            <textarea
                className={`w-full px-[16px] py-[12px] rounded-[8px] border-none text-[16px] outline-none resize-none transition-colors duration-200 focus:border-[#CD6D2C] focus:border-solid focus:border-[1px] ${
                    isDark
                        ? 'bg-[#161515] text-white placeholder:text-[#b3b3b3]'
                        : 'bg-white text-[#072837] placeholder:text-[#686868]'
                }`}
                placeholder="Notes"
                id="notes-textarea"
                rows="5"
                aria-label='Notes'
                value={formData.notes}
                onChange={(e) => handleInputChange('notes', e.target.value)}
            />
        </div>
    );
};

export default NotesSection;
